// @ts-expect-error
import { PostMessageTransportBackend, Transport } from '@jitsi/js-utils/transport';
import { APP_WILL_MOUNT, APP_WILL_UNMOUNT } from '../base/app/actionTypes';
import { CONFERENCE_JOINED } from '../base/conference/actionTypes';
import { PARTICIPANT_LEFT, PARTICIPANT_UPDATED } from '../base/participants/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { onSignatureAPIEvent } from './functions';
import { setReceiverTransport } from './actions';
/**
 * The redux middleware for the remote control feature.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => async (action) => {
    switch (action.type) {
        case PARTICIPANT_UPDATED: {
            const result = next(action);
            const { getState } = store;
            const { transport } = getState()['features/signature'].receiver;
            onSignatureAPIEvent(store);
            return result;
        }
        case APP_WILL_MOUNT: {
            const { dispatch } = store;
            dispatch(setReceiverTransport(new Transport({
                backend: new PostMessageTransportBackend({
                    postisOptions: { scope: 'signature' }
                })
            })));
            break;
        }
        case APP_WILL_UNMOUNT: {
            const { getState, dispatch } = store;
            const { transport } = getState()['features/signature'].receiver;
            if (transport) {
                transport.dispose();
                dispatch(setReceiverTransport());
            }
            break;
        }
        case CONFERENCE_JOINED: {
            const result = next(action);
            const { getState } = store;
            const { transport } = getState()['features/signature'].receiver;
            onSignatureAPIEvent(store);
            return result;
        }
        case PARTICIPANT_LEFT: {
            const { getState, dispatch } = store;
            const state = getState();
            const { id } = action.participant;
            const { receiver, controller } = state['features/signature'];
            const { requestedParticipant, controlled } = controller;
            break;
        }
    }
    return next(action);
});
